import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from "hooks/auth";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // user is not authenticated - redirect to login with return URL
    const shouldRedirect = !location.pathname.includes('/profile') && location.pathname !== '/';
    const redirectPath = shouldRedirect ? `?redirect=${encodeURIComponent(location.pathname + location.search)}` : '';
    return <Navigate to={`/login${redirectPath}`} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
